import { FlexBox, SelectionList, Spinner, Text } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { Dispatch, SetStateAction } from 'react';

import type { Language } from 'app/utils/supportedLanguages';

import styles from './languageSelector.module.scss';

type LanguageSelectorProps = {
  languages: Language[];
  selectedLanguage: Language;
  setSelectedLanguage: Dispatch<SetStateAction<Language>>;
  isLoading: boolean;
};

export const LanguageSelector = ({
  languages,
  selectedLanguage,
  setSelectedLanguage,
  isLoading,
}: LanguageSelectorProps): JSX.Element | null => {
  return (
    <FlexBox
      borderWidth="0 1px 0 0"
      borderColor="neutral.200"
      height="320px"
      width="140px"
      flexDirection="column"
      justifyContent="center"
    >
      <SelectionList
        className={styles.list}
        onChange={(list) => {
          const language = list.selectedValues[0];
          setSelectedLanguage(language);
          ampli.quickReplyLanguageSelected({
            language: language.label,
          });
        }}
        selectedValues={selectedLanguage ? [selectedLanguage] : undefined}
      >
        {(isLoading && (
          <FlexBox display="flex" alignItems="center" justifyContent="center">
            <Spinner size={32} />
          </FlexBox>
        )) ||
          languages.map((language) => (
            <SelectionList.Item
              key={language.code}
              value={language}
              title={language.label}
              className={styles.listItem}
            >
              <Text.Paragraph>{language.label}</Text.Paragraph>
            </SelectionList.Item>
          ))}
      </SelectionList>
    </FlexBox>
  );
};
